import { useState } from "react";
import "./AffichListFilms.css";

export default function FormTexte({ handler }) {
  const [texte, setTexte] = useState("");

  const handleSubmit = (event) => {
    event.preventDefault();
    console.log(texte);
    handler(texte);
  };

  return (
    <form className="search-form" onSubmit={handleSubmit}>
      <input
        className="search-input"
        type="text"
        value={texte}
        onChange={(e) => setTexte(e.target.value)}
        placeholder="Rechercher un film..."
      />
      <button className="search-button" type="submit">Rechercher</button>
    </form>
  );
}
